export default __webpack_public_path__ + "media/images/gm_plus/gmplus_tile-fc052f8395c8fca25d72722dd8e479d2.jpg";